<template>
    <div class="container" v-title="'个人报名'">
        <Navigation-bar v-scrollShadow="roll" :title="roll > titleH ? '个人报名' : ''"></Navigation-bar>
        <div class="container_content" v-show="pageShow">
            <div id="AuditDetail">
                <Scroll
                    :scroll="roll"
                    @scrollChange="roll = $event"
                >
                    <Pull-refresh 
                        v-model="pullRefresh.loading" 
                        loosing-text="释放刷新数据"
                        loading-text="正在刷新数据..." 
                        :success-text="pullRefresh.text" 
                        @refresh="onRefresh"
                    >
                        <Title subtitle="修改/取消报名信息" class="page_title">
                            <template slot="spreadhead">
                                <span>个人报名</span>
                                <span class="noPay" v-if="isNoPay">未支付服务费</span>
                            </template>
                        </Title>
                        <div class="list">
                            <ul>
                                <li v-for="(item,index) in groups" :key="index">
                                    <div class="group_title">
                                        <div class="name">{{item.GroupInfo.Name}}</div>
                                        <div class="status" v-if="item.EnrollStatus == 1">
                                            <YD-image src="icon/no_audit"></YD-image>
                                        </div>
                                        <div class="status" :class="{'error': [4,6,8].includes(item.EnrollStatus)}" v-else-if="item.EnrollStatus != null">（{{statusText[item.EnrollStatus]}}）</div>
                                        <div v-else></div>
                                    </div>
                                    <div class="members">
                                        <ol :class="{
                                            'double':item.GroupInfo.GroupType == 3
                                        }">
                                            <li v-for="(userItem,userIndex) in item.UserList" :key="userIndex">
                                                <div class="member_info">
                                                    <div class="member_img">
                                                        <img :src="getUserPhoto(userItem)" class="member_img">
                                                    </div>
                                                    <span>{{userItem.Name}}</span>
                                                    <span class="status error" v-if="item.GroupInfo.GroupType == 3 && userItem.IsImpeached">（公示有问题）</span>
                                                    <span v-else></span>
                                                </div>
                                                <div class="member_role">{{userItem.EnrollRoleList[0].RoleName}}{{userItem.JerseyNumber ? `(${userItem.JerseyNumber})` : ''}}</div>
                                            </li>
                                        </ol>
                                    </div>
                                    <div class="operation" v-if="isOption">
                                        <span></span>
                                        <div>
                                            <button v-href="`/Enroll/OneselfEnroll/TeammateInfo?subLeagueId=${subLeagueId}&groupId=${item.GroupInfo.Id}`" v-if="item.GroupInfo.GroupType == 3 && !item.IsAddTeammate" class="addTeammate">
                                                <span>添加队友</span>
                                                <div>请添加队友</div>
                                            </button>
                                            <button v-href="`/Enroll/OneselfEnroll/UpdatePersonnel?subLeagueId=${subLeagueId}&groupId=${item.GroupInfo.Id}`" v-else>修改报名</button>
                                            <button @click="deleteGroup(item)">取消报名</button>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <ul>
                                <li v-for="(item,index) in noEnrollGroup" :key="index">
                                    <div class="group_title">
                                        <div class="name">{{item.Name}}<span v-if="getGroupFull(item)">（已报满）</span></div>
                                        <div></div>
                                    </div>
                                    <div class="operation" v-if="isOption">
                                        <span>未报名该组</span>
                                        <div>
                                            <button @click="enroll(item)">我要报名</button>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Pull-refresh>
                </Scroll>
            </div>
        </div>
        <div class="bottom_operation" v-if="isOption" v-show="pageShow">
            <button @click="submit()">
                <span>提交审核</span>
                <div class="bubble" v-if="isNoSubmitAudit">有组别待提交审核</div>
            </button>
        </div>
    </div>
</template>
<script>
import { PullRefresh } from 'vant';
import 'vant/lib/pull-refresh/style';
import {
    convertSize
} from '@js';
import {
    CancelIndividualEnrollGroup,
    SubmitIndividualEnroll,
    GetMyIndividualEnroll,
    IndividualEnrollOneGroup,
    GetUserEnrollPayStatusInfo, //查询支付状态
    CreateIndividualLeagueEnrollOrder //创建订单
} from '@/api';
import appInteraction from '@/common/appInteraction.js';
import communicate from '@/common/communicate.js';
import tools from '@/common/tools.js';

const watch = {};
const keys = ['ONESELF_ENROLL_MY_INFO', 'ONESELF_ENROLL_TEAMMATE_INFO','ONESELF_ENROLL_GROUP_CANCEL','ONESELF_ENROLL_DOUBLE_DELETE','ENROLL_UPDATE_PHONE'];
for(let key of keys){
    watch['$store.state.monitor.'+key] = {
        deep: true,
        handler(){
            this.getData();
        }
    }
}
export default {
    name:"AuditDetail",
    components: {
        PullRefresh
    },
    data(){
        return{
            subLeagueId: 0,
            isGetAuditInfo: true,
            pageShow: true,
            roll:0,
            titleH:0,
            groups: [],
            noEnrollGroup: [],
            enrollQuotaStores: [],
            isOption:true,
            isGetData: false,
            isNoPay: false,
            pullRefresh:{
                loading:false,
                text:''
            },
            firstEnter: false, //是否首次进入页面
            hintShowed: false, //重要提示已经显示过
        }
    },
    beforeRouteEnter(to, from, next){
        next(vm => {
            if (from.name === 'Personnel' || from.name === 'EnrollRecord') {
                vm.firstEnter = true;
            } else {
                vm.firstEnter = false;
            }
        });
    },
    created(){
        this.subLeagueId = +this.$route.query.subLeagueId;
        this.isGetAuditInfo = +this.$route.query.audit != 1;
        this.getData();
    },
    mounted(){
        this.titleH = convertSize(1.88);
    },
    computed:{
		statusText(){
			return ['','未提交审核','组委会审核中','组委会审核中','审核有问题','公示中','公示有问题','报名成功','报名失败'];
		},
		portraitUnknown(){
			return require(`@images/portrait_unknown@3x.png`);
		},
		portraitMan(){
			return require(`@images/肖像_男@3x.png`);
		},
		portraitWoman(){
			return require(`@images/肖像_女@3x.png`);
		},
		isNoSubmitAudit(){
			return this.groups.some(item=>item.EnrollStatus == 1);
		}
    },
    watch:{
        ...watch
    },
    methods:{
		getUserPhoto(UserInfo){
			if(UserInfo.PhotolUrl){
				return UserInfo.PhotolUrl;
			}else if(UserInfo.Gender == 1){
				return this.portraitMan;
			}else if(UserInfo.Gender == 2){
				return this.portraitWoman;
			}
			return this.portraitUnknown;
		},
        getData(isRefresh){
            if(this.isGetData) return;
            this.isGetData = true;
            GetMyIndividualEnroll({
                LeagueId: this.subLeagueId
            }).then(data=>{
                if(isRefresh){
                    this.pullRefresh.loading = false;
                    this.pullRefresh.text = data.Code == 0 ? "数据刷新成功" : "数据刷新失败";
                }
                this.isGetData = false;
                if(data.Code == 0){
                    this.pageShow = true;
					this.isNoPay = data.IsNotPaid;
                    this.groups = data.EnrollGroup || [];
                    this.noEnrollGroup = data.NoEnrollGroup || [];
                    this.enrollQuotaStores = data.EnrollQuotaStores || [];
                    if(this.firstEnter && !this.hintShowed && this.isGetAuditInfo){
                        this.$nextTick(()=>{
                            this.hintShowed = true;
                            this.$Prompt({
                                title: '重要提示',
                                message: '如果您对自己或队友的报名信息进行了修改，报名将被自动撤销。请您在修改完成后务必重新提交审核。',
                                confirmText: '我知道了'
                            })
                        });
                    }
                }
            }).catch(()=>{
                if(isRefresh){
                    this.pullRefresh.loading = false;
                    this.pullRefresh.text = "数据刷新失败";
                }
                this.isGetData = false;
            })
        },
        onRefresh(){
            this.getData(true);
        },
        deleteGroup(obj){
			let title = '温馨提示',
				message = '您确定要取消该组别的报名吗？';
            if(obj.IsAgentEnroll){
				title = '该组别由队友代报名';
				message = '操作后，队友不再与您配对，TA可以更换其他人配对报名该组别。是否继续？';
            }
            this.$Prompt({
                title,
                message,
                showCancel: true
            }).then(confirm=>{
                if(confirm){
                    CancelIndividualEnrollGroup({
                        LeagueId: this.subLeagueId,
                        GroupId: obj.GroupInfo.Id
                    }).then(data=>{
                        if(data.Code == 0){
                            this.$Toast('取消报名成功','success');
                            this.getData();
                        }
                    })
                }
            })
        },
		getGroupFull({Id}){
			let obj = this.enrollQuotaStores.find(item=>item.GroupInfo.Id == Id);
			return obj && obj.TotalNum > 0 && obj.LeftNum == 0;
		},
        enroll(obj){
			// if(this.getGroupFull(obj)){
            //     this.$Toast.warning('该组别已报满');
			// 	return;
			// }
            IndividualEnrollOneGroup({
                LeagueId: this.subLeagueId,
                GroupId: obj.Id
            }).then(data=>{
                if(data.Code == 0){
                    this.$Toast('添加成功','success');
                    this.getData();
                }
            })
        },
        submit(){
            SubmitIndividualEnroll({
                LeagueId: this.subLeagueId
            }).then(data=>{
                if(data.Code == 0){
                    communicate.enrollPayStatus.$emit();
					if(data.IsFrist){
						this.showPay();
                    }else{
                        this.submitSuccess();
                    }
                }else if(data.Code == 3901){
					let enrollQuotaStores = data.EnrollQuotaStores;
					let html = enrollQuotaStores.map(item=>`<p style="text-align: center;">${item.GroupInfo.Name}</p>`).join('');
					this.$Prompt({
						title: '以下组别已报满，请返回修改：',
						message: html,
						confirmText: '知道了'
					})
				}
            })
        },
		showPay(isConfirm){
			GetUserEnrollPayStatusInfo({
				LeagueId: this.subLeagueId
			}).then(data => {
				if(data.Code == 0){
                    if(isConfirm){
                        this.$Prompt({
                            title: '温馨提示',
                            message: data.IsNotPaid ? '未查询到支付成功' : '支付成功',
                            confirmText: "知道了"
                        }).then(()=>{
                            this.$navigation.back();
                        })
                    }else{
                        if(data.IsNotPaid){
                            this.$Prompt({
                                title: '温馨提示',
                                message: `<p>你需支付 <span style="color: #7AD21A">${data.TotalFee}元</span> 赛事服务费(${data.Price})锁定参赛资格，支付后不影响修改报名信息。</p>`,
                                showCancel: true,
                                cancelText: "暂不",
                                confirmText: "去支付"
                            }).then(confirm=>{
                                if(confirm){
                                    this.go2Pay();
                                }else{
                                    this.submitSuccess();
                                }
                            })
                        }else{
                            this.submitSuccess();
                        }
                    }
				}
			})
		},
		go2Pay(){
			CreateIndividualLeagueEnrollOrder({
				LeagueId: this.subLeagueId
			}).then(data => {
				if(data.Code == 0){
                    if(tools.isVersion('23061600')){
                        this.$navigation.replace(`/Pay/EnrollCashier?money=${data.FeeTotal}&type=2&id=${data.LeagueEnrollOrderId}`);
                    }else{
                        let title,
                            message;
                        if(tools.isVersion('23060800')){
                            title = "支付提示";
                            message = `您是否已在微信小程序中完成支付?`;
                            appInteraction.jumpWxMiniApp(`/pages/pay/enrollCashier/enrollCashier?money=${data.FeeTotal}&type=201&id=${data.LeagueEnrollOrderId}`);
                        }else{
                            title = "去小程序支付";
                            message = `烦请您进入微信「亿动体育」小程序完成支付。<br/>
                                打开微信 >> 点击搜索 >> 选择小程序 >> 查找「亿动体育」>> 进入小程序`;
                        }
                        this.$Prompt({
                            title,
                            message,
                            showCancel: true,
                            cancelText: "未支付",
                            confirmText: "已支付"
                        }).then(confirm=>{
                            if(confirm){
                                this.showPay(true);
                            }else{
                                this.$navigation.back();
                            }
                        })
                    }
				}
			})
		},
        submitSuccess(){
			this.$api.GetSubleagueMatchGroupSetting({
				SubLeagueId: this.subLeagueId
			}).then(data=>{
				if(data.MatchGroupSetting && data.MatchGroupSetting.MatchGroupEnrollRemind == 1){
                    this.$Prompt({
                        title: '报名提交成功',
                        message: '请加入赛事官方微信群，以便随时获得赛事最新信息。',
                        showCancel: true,
                        cancelText: '我已入群',
                        confirmText: '去加群'
                    }).then(confirm=>{
                        if(confirm){
                            appInteraction.jumpWxMiniApp(`/pages/Match/MatchDetail/MatchDetail?SubLeagueId=${this.subLeagueId}&go=groupQRCode`);
                        }
                        this.$navigation.back();
                    })
                }else{
                    this.$Prompt({
                        title: '提交成功',
                        message: '请在APP中随时关注审核结果',
                        confirmText: "知道了"
                    }).then(()=>{
                        this.$navigation.back();
                    })
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin button{
    width: 192px;
    @include line-height(64px);
    font-size: 28px;
    color: #404349;
    letter-spacing: 0;
    font-weight: 500;
    border: 2px solid rgba(233,233,233,1);
    border-radius: 33px;
    margin-left: 16px;
}
#AuditDetail{
    padding-bottom: calc(150px + var(--safe-area-inset-bottom));
    box-sizing: border-box;
}
.share{
    width: 48px;
    height: 48px;
    margin-right: -6px;
}
.page_title{
	position: relative;
	.noPay{
		font-size: 34px;
		color: #F34911;
		line-height: 34px;
		position: absolute;
		right: 40px;
		top: calc(50% - 17px);
	}
}
.list{
    padding: 0 40px;
    box-sizing: border-box;
    ul>li{
        width: 100%;
        height: auto;
        padding: 12px 26px 8px;
        box-sizing: border-box;
        background: #FFFFFF;
        box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
        border-radius: 20px;
        margin-bottom: 24px;
        .group_title{
            width: 100%;
            min-height: 84px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px #F0F0F0 solid;
            .name{
                font-size: 32px;
                color: #1B1C1E;
                font-weight: 500;
				line-height: 44px;
				word-break: break-all;
				padding: 20px 0;
				padding-right: 40px;
				box-sizing: border-box;
                span{
                    color: #7E7E7F;
                }
            }
            .status{
                font-size: 28px;
                font-weight: 400;
                color: #7E7E7F;
				white-space: nowrap;
                &.error{
                    color: #F06E43; 
                }
                img{
                    width: 162px;
                    height: 40px;
                }
            }
        }
        .members{
            height: auto;
            ol{
                padding: 19px 0 0;
                overflow: hidden;
                &.double{
                    height: 128px;
                }
                li{
                    height: 56px;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 16px;
                    &:last-of-type{
                        margin-bottom: 0;
                    }
                    .member_info{
                        display: flex;
                        align-items: center;
                        .member_img{
                            width: 56px;
                            height: 56px;
                            border-radius: 20px;
                            overflow: hidden;
                            display: flex;
                            align-items: center;
                            img{
                                width: 100%;
                            }
                        }
                        span{
                            font-size: 28px;
                            color: #1B1C1E;
                            font-weight: 400;
                            padding-left: 24px;
                        }
                        .status{
                            font-size: 28px;
                            font-weight: 400;
                            color: #7E7E7F;
                            padding: 0;
                            &.error{
                                color: #F06E43; 
                            }
                        }
                    }
                    .member_role{
                        font-size: 28px;
                        color: #999999;
                        font-weight: 400;
                    }
                }
            }
            
        }
        .operation{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 24px 0;
            span{
                font-size: 28px;
                color: #7E7E7F;
                font-weight: 400;
            }
            button{
                @include button;
                &.addTeammate{
                    background: #1B1C1E;
                    position: relative;
                    span{
                        color: #FFFFFF;
                    }
                    div{
                        width: 178px;
                        height: 52px;
                        font-size: 26px;
                        color: #F06E43;
                        letter-spacing: 0;
                        text-align: center;
                        font-weight: 400;
                        line-height: 52px;
                        background: #FFE9E2;
                        border-radius: 12px;
                        position: absolute;
                        top: -72px;
                        left: 7px;
                        &::after{
                            content: '';
                            width: 24px;
                            height: 24px;
                            border-radius: 3px;
                            background: linear-gradient(-45deg, #FFE9E2 50%, transparent 50%);
                            position: absolute;
                            left: calc(50% - 12px);
                            top: calc(100% - 15px);
                            transform: rotate(45deg);
                        }
                    }
                }
            }
        }
    }
}
.bottom_operation{
    @include bottom-button;
    
    button{
        position: relative;
		.bubble{
			width: 224px;
			height: 42px;
			background: url('~@images/enroll/bubble_audit@2x.png') no-repeat center / 100%;
			position: absolute;
			top: -24px;
			left: 22px;
			
			font-weight: 500;
			font-size: 24px;
			color: #FFFFFF;
			line-height: 38px;
		}
    }
}
</style>